import { supabase } from '../../../services/supabaseClient';

/**
 * User integration status — VIT LMS / ICS feed only.
 */
export const integrationStatusService = {
    /**
     * LMS row: vit_username, ics_feed_url (after validate_and_store).
     */
    getLmsCalendarStatus: async (userId) => {
        const { data, error } = await supabase
            .from('users')
            .select('vit_username, ics_feed_url')
            .eq('user_id', userId)
            .maybeSingle();

        if (error) {
            console.error('[LMS status] Error:', error);
            throw error;
        }

        const feedUrl = data?.ics_feed_url?.trim() || '';
        return {
            connected: feedUrl.length > 0,
            username: data?.vit_username || null,
            feedUrl: feedUrl || null,
        };
    },

    /**
     * Clears VIT LMS credentials and ICS feed from the user's profile (revoke).
     */
    clearLmsCredentials: async (userId) => {
        const { error } = await supabase
            .from('users')
            .update({
                vit_username: null,
                vit_password: null,
                ics_feed_url: null,
            })
            .eq('user_id', userId);

        if (error) {
            console.error('[LMS revoke] Error:', error);
            throw error;
        }
    },
};
